import { FormControl, Box, Typography } from '@mui/material';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import CustomAlert from '../../../../../../layout/styledcomponents/CustomAlert';
import FormCheckbox from '../../../../../shared/FormCheckbox';
import StaffAttendees from './StaffAttendees';

interface OwnerAttendeesProps {
    experienceDetails: any;
    usesFaceRec: boolean;
    isEditing: boolean;
}

export const OwnerAttendeesSection = ({
    experienceDetails,
    usesFaceRec,
    isEditing,
}: OwnerAttendeesProps) => {
    const { control } = useFormContext();
    const staffAttending = useWatch({ name: 'staffAttending' }) || [];
    const removeNirovisionAccess = useWatch({
        name: 'removeNirovisionAccess',
    });

    return (
        <>
            <StaffAttendees
                experienceType={experienceDetails?.type}
                usesFaceRec={usesFaceRec}
                isEditing={isEditing}
            />
            {usesFaceRec && staffAttending.length > 0 && (
                <FormControl sx={{ mt: 0.5 }}>
                    <Box display='flex' alignItems='center'>
                        <FormCheckbox
                            control={control}
                            name='removeNirovisionAccess'
                        />
                        <Typography
                            variant='body2'
                            sx={{ ml: 1, lineHeight: 1.35 }}
                            component='label'
                        >
                            Revoke Nirovision access after checkout
                        </Typography>
                    </Box>
                    {removeNirovisionAccess && (
                        <CustomAlert
                            severity='info'
                            fontSize='12px'
                            variant='outlined'
                            sx={{ mt: 1 }}
                        >
                            Nirovision labels assigned to the experience will be
                            removed from selected attendees after checkout.
                        </CustomAlert>
                    )}
                </FormControl>
            )}
        </>
    );
};
